var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 0.109375H3.3C1.1 0.109375 0 1.20938 0 3.40938L0.000649095 18.8094C0.000649095 21.0094 1.10023 22.1094 3.30023 22.1094H18.7002C20.9002 22.1094 22.0002 21.0094 22.0002 18.8094V3.40938C22.0002 1.20938 20.9002 0.109375 18.7002 0.109375ZM7.33357 17.5261H4.58356V7.44272H7.33357V17.5261ZM5.95856 6.28038C5.07306 6.28038 4.3544 5.55622 4.3544 4.66338C4.3544 3.77054 5.07306 3.04638 5.95856 3.04638C6.84406 3.04638 7.56274 3.77054 7.56274 4.66338C7.56274 5.55622 6.84499 6.28038 5.95856 6.28038ZM18.3336 17.5261H15.5836V12.3891C15.5836 9.30173 11.9169 9.53548 11.9169 12.3891V17.5261H9.16686V7.44272H11.9169V9.06061C13.1966 6.69013 18.3336 6.51506 18.3336 11.3304V17.5261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinImage);
export default __webpack_public_path__ + "static/media/linkedin-image.7bda5c19eaf6dbd9bcc1104826e9a27a.svg";
export { ForwardRef as ReactComponent };